import React from "react";
import { Link } from "react-router-dom";

export default function CTASection({ title, subtitle, primaryCta, secondaryCta }) {
  return (
    <section className="eb-section">
      <div className="eb-container">
        <div className="relative overflow-hidden rounded-3xl border border-slate-200 bg-gradient-to-br from-slate-900 to-brand-950 px-6 py-12 text-white sm:px-10">
          <div className="absolute -top-16 right-[-10%] h-64 w-64 rounded-full bg-brand-500/20 blur-3xl" />
          <div className="absolute -bottom-16 left-[-10%] h-64 w-64 rounded-full bg-white/10 blur-3xl" />

          <div className="relative max-w-2xl">
            <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight">{title}</h2>
            {subtitle ? <p className="mt-4 text-white/80 text-lg">{subtitle}</p> : null}

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              {primaryCta ? (
                <Link to={primaryCta.to} className="eb-btn bg-white text-slate-900 hover:bg-white/90">
                  {primaryCta.label}
                </Link>
              ) : null}
              {secondaryCta ? (
                <Link to={secondaryCta.to} className="eb-btn bg-white/10 text-white hover:bg-white/15">
                  {secondaryCta.label}
                </Link>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

